import { HStack, Stack, Text, VStack } from '@chakra-ui/react';
import { TooltipComponentProps, TooltipTypeEnum } from '@components/map/tooltips/tooltip.types';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectCoordinatesUnit } from '@redux/settings/settings.selectors';
import { formatTimeTwoDigits, minutesToTime } from '@utils/date.utils';
import { eventColor } from '@utils/replay/event.utils';
import { formatCoordinatesToString } from '@utils/validation/coordinates.utils';
import { format } from 'date-fns';
import DmsCoordinates from 'dms-conversion';
import { capitalize } from 'lodash';
import { FaCircle } from 'react-icons/fa';
import { FormattedMessage, useIntl } from 'react-intl';

function EventTooltip({ data }: Readonly<TooltipComponentProps<TooltipTypeEnum.EVENT>>) {
  const userSettingsUnit = useAppSelector(selectCoordinatesUnit);
  const coordinates = new DmsCoordinates(data.position!.latitude, data.position!.longitude);
  const [durationHours, durationMinutes] = minutesToTime(data.duration);
  const { formatMessage } = useIntl();
  return (
    <VStack gap={1.5} alignItems="start" maxWidth="500px">
      <Stack gap={0}>
        <Text textStyle="md">
          <FormattedMessage id="live.event.name" />
        </Text>
        <Text textStyle="md">{capitalize(data.name)}</Text>
      </Stack>
      <Stack gap={0}>
        <Text textStyle="md">
          <FormattedMessage id="live.event.type" />
        </Text>
        <HStack>
          <FaCircle color={eventColor[data.observationType]} />
          <Text textStyle="md">{formatMessage({ id: `live.event.types.${data.observationType}` })}</Text>
        </HStack>
      </Stack>
      <Stack gap={0}>
        <Text textStyle="md">
          <FormattedMessage id="live.event.location" />
        </Text>
        <HStack>
          <Text>
            <FormattedMessage id="live.event.latLong" />
          </Text>
          <Text textStyle="md" fontWeight="600">
            {formatCoordinatesToString(coordinates, userSettingsUnit)}
          </Text>
        </HStack>
      </Stack>
      <Stack gap={0}>
        <Text textStyle="md">
          <FormattedMessage id="live.event.dateTime" />
        </Text>
        <Text textStyle="md">{format(new Date(data.startDate), "dd/MM/yyyy' 'HH'h'mm")}</Text>
      </Stack>
      <Stack gap={0}>
        <Text textStyle="md">
          <FormattedMessage id="live.event.duration" />
        </Text>
        <Text textStyle="md">
          {formatTimeTwoDigits(durationHours.toString())}h{formatTimeTwoDigits(durationMinutes.toString())}
        </Text>
      </Stack>
      <Stack gap={0}>
        <Text textStyle="md">
          <FormattedMessage id="live.event.comment" />
        </Text>
        <Text>{data.comment ? data.comment : formatMessage({ id: `live.event.noComment` })}</Text>
      </Stack>
    </VStack>
  );
}

export default EventTooltip;
